// import React, { useEffect, useState } from 'react'
// import { Input } from 'antd'
// import { SearchOutlined } from '@ant-design/icons'
// import axios from 'axios'
// import { toast } from 'react-toastify'
// import { GetJobPost, IMG_BASE_URL3 } from '../../../AllAPI/AdminAPI'

// function getInitials(name = '') {
//   return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || '?'
// }

// export default function AllJobPostDetails() {
//   const [data, setData] = useState([])
//   const [searchText, setSearchText] = useState('')
//   const [activeId, setActiveId] = useState(null)
//   const [loading, setLoading] = useState(false)

//   const studentData = JSON.parse(sessionStorage.getItem('studentData'))
//   const year = studentData.year

//   const fetchJobs = async () => {
//     try {
//       setLoading(true)
//       const res = await axios.get(`${GetJobPost}/${year}`)
//       setData(res.data || [])
//     } catch {
//       toast.error('Failed to load jobs')
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => { fetchJobs() }, [])

//   const filtered = data.filter(item =>
//     item.job_title?.toLowerCase().includes(searchText.toLowerCase())
//   )

//   return (
//     <div className="form-container mainContainer">
//       <div className="row p-0 m-0 pb-5">
//         <div className="col-12 col-md-2" />
//         <div className="col-12 col-md-8">

//           <div className="header-row">
//             <h2 className="page-title">Job Posts</h2>
//           </div>

//           {/* Search */}
//           <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <span style={{ fontSize: 13, color: '#888' }}>{filtered.length} open position{filtered.length !== 1 ? 's' : ''}</span>
//             <Input
//               placeholder="Search jobs..."
//               prefix={<SearchOutlined />}
//               value={searchText}
//               onChange={e => setSearchText(e.target.value)}
//               style={{ width: 220 }}
//             />
//           </div>

//           {/* Job List */}
//           {loading ? (
//             <p style={{ color: '#888', textAlign: 'center', padding: 40 }}>Loading...</p>
//           ) : (
//             <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
//               {filtered.map(job => {
//                 const isActive = activeId === job.id
//                 return (
//                   <React.Fragment key={job.id}>
//                     {/* Card Row */}
//                     <div
//                       onClick={() => setActiveId(isActive ? null : job.id)}
//                       style={{
//                         background: isActive ? '#f0f7ff' : '#fff',
//                         border: isActive ? '1px solid #378ADD' : '0.5px solid #e0e0e0',
//                         borderRadius: 12,
//                         padding: '14px 18px',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'space-between',
//                         transition: 'all 0.15s',
//                       }}
//                     >
//                       <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//                         <div style={{
//                           width: 38, height: 38, borderRadius: 8,
//                           background: '#E6F1FB', color: '#185FA5',
//                           display: 'flex', alignItems: 'center', justifyContent: 'center',
//                           fontWeight: 500, fontSize: 13, flexShrink: 0,
//                         }}>
//                           {job.job_title?.slice(0, 2).toUpperCase()}
//                         </div>
//                         <div>
//                           <p style={{ margin: 0, fontWeight: 500, fontSize: 14, color: '#1a1a1a' }}>{job.job_title}</p>
//                           <p style={{ margin: 0, fontSize: 12, color: '#888', marginTop: 2 }}>
//                             {job.industry_name} · {job.experience}
//                           </p>
//                         </div>
//                       </div>
//                       <span style={{
//                         fontSize: 18, color: isActive ? '#378ADD' : '#bbb',
//                         transform: isActive ? 'rotate(90deg)' : 'none',
//                         transition: 'transform 0.2s',
//                         lineHeight: 1,
//                       }}>›</span>
//                     </div>

//                     {/* Detail Panel */}
//                     {isActive && (
//                       <div style={{
//                         background: '#fff',
//                         border: '1px solid #378ADD',
//                         borderRadius: 12,
//                         padding: '20px 22px',
//                         animation: 'slideDown 0.18s ease',
//                       }}>
//                         {/* Title + badge */}
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
//                           <p style={{ margin: 0, fontWeight: 500, fontSize: 16 }}>{job.job_title}</p>
//                           <span style={{
//                             fontSize: 11, padding: '3px 10px', borderRadius: 999,
//                             background: '#E6F1FB', color: '#185FA5', fontWeight: 500,
//                           }}>
//                             {job.job_category_name?.category_name}
//                           </span>
//                         </div>

//                         {/* Fields grid */}
//                         <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 20px', marginBottom: 16 }}>
//                           {[
//                             ['Experience', job.experience],
//                             ['Industry', job.industry_name],
//                             ['Qualification', job.qualification],
//                             ['Vacancies', job.vaccancy || '–'],
//                             ['Contact', job.contact],
//                           ].map(([label, value]) => (
//                             <div key={label}>
//                               <p style={{ margin: 0, fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{label}</p>
//                               <p style={{ margin: 0, fontSize: 13 }}>{value}</p>
//                             </div>
//                           ))}
//                           <div style={{ gridColumn: '1 / -1' }}>
//                             <p style={{ margin: 0, fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Description</p>
//                             <p style={{ margin: 0, fontSize: 13, lineHeight: 1.6 }}>{job.discription}</p>
//                           </div>
//                         </div>

//                         <hr style={{ border: 'none', borderTop: '0.5px solid #e8e8e8', margin: '14px 0' }} />

//                         {/* Posted by */}
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                           <div style={{
//                             width: 34, height: 34, borderRadius: '50%',
//                             background: '#E1F5EE', color: '#0F6E56',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center',
//                             fontSize: 12, fontWeight: 500, flexShrink: 0,
//                           }}>
//                             {getInitials(job.alumini?.fullName)}
//                           </div>
//                           <div>
//                             <p style={{ margin: 0, fontWeight: 500, fontSize: 13 }}>{job.alumini?.fullName}</p>
//                             <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{job.alumini?.email}</p>
//                           </div>
//                         </div>

//                         {/* Image */}
//                         {job.jobpost_image && (
//                           <>
//                             <hr style={{ border: 'none', borderTop: '0.5px solid #e8e8e8', margin: '14px 0' }} />
//                             <img
//                               src={`${IMG_BASE_URL3}${job.jobpost_image}`}
//                               alt="job"
//                               style={{ width: '100%', borderRadius: 8, objectFit: 'cover' }}
//                             />
//                           </>
//                         )}
//                       </div>
//                     )}
//                   </React.Fragment>
//                 )
//               })}
//             </div>
//           )}

//         </div>
//         <div className="col-12 col-md-2" />
//       </div>

//       <style>{`
//         @keyframes slideDown {
//           from { opacity: 0; transform: translateY(-6px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//       `}</style>
//     </div>
//   )
// }

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import { GetJobPost, IMG_BASE_URL3 } from '../../../AllAPI/AdminAPI'

const COLORS = [
  { logo: '#E6F1FB', logoTxt: '#0C447C', avatar: '#E6F1FB', avatarTxt: '#0C447C' },
  { logo: '#E1F5EE', logoTxt: '#085041', avatar: '#E1F5EE', avatarTxt: '#085041' },
  { logo: '#EEEDFE', logoTxt: '#3C3489', avatar: '#EEEDFE', avatarTxt: '#3C3489' },
]
const PILL_COLORS = [
  { bg: '#E6F1FB', txt: '#0C447C' },
  { bg: '#E1F5EE', txt: '#085041' },
  { bg: '#FAEEDA', txt: '#633806' },
  { bg: '#EEEDFE', txt: '#3C3489' },
]

function initials(name = '') {
  return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || '?'
}
function logoLetters(title = '') {
  return title.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
}

const ChevronIcon = ({ open }) => (
  <svg
    width="16" height="16" viewBox="0 0 16 16" fill="none"
    stroke="currentColor" strokeWidth="1.5"
    style={{ transition: 'transform .2s', transform: open ? 'rotate(90deg)' : 'none', color: open ? '#378ADD' : '#aaa', flexShrink: 0 }}
  >
    <path d="M6 4l4 4-4 4" />
  </svg>
)

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"
    style={{ position: 'absolute', left: 10, color: '#aaa' }}>
    <circle cx="6.5" cy="6.5" r="4.5" /><path d="M10.5 10.5l3 3" />
  </svg>
)

export default function AllJobPostDetails() {
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [activeId, setActiveId] = useState(null)
  const [loading, setLoading] = useState(false)

  const studentData = JSON.parse(sessionStorage.getItem('studentData'))
  const year = studentData.year

  useEffect(() => {
    (async () => {
      try {
        setLoading(true)
        const res = await axios.get(`${GetJobPost}/${year}`)
        setData(res.data || [])
      } catch {
        toast.error('Failed to load jobs')
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  const filtered = data.filter(j =>
    j.job_title?.toLowerCase().includes(search.toLowerCase())
  )

  return (
    <div className="form-container mainContainer">
      <style>{`
        @keyframes jbSlide {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .jb-card { transition: border-color .15s; }
        .jb-card:hover { border-color: rgba(0,0,0,0.2) !important; }
        .jb-row-btn:hover { background: #f8f9fa; }
      `}</style>

      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-3" />
        <div className="col-12 col-md-6">

          <div className="header-row">
            <h2 className="page-title">Job Posts</h2>
          </div>

          {/* Top bar */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
            <span style={{ fontSize: 13, color: '#888' }}>
              {filtered.length} open position{filtered.length !== 1 ? 's' : ''}
            </span>
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <SearchIcon />
              <input
                type="text"
                placeholder="Search jobs..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{
                  padding: '7px 12px 7px 32px', fontSize: 13,
                  border: '0.5px solid #d0d0d0', borderRadius: 8,
                  outline: 'none', width: 200,
                }}
              />
            </div>
          </div>

          {/* Cards */}
          {loading ? (
            <p style={{ textAlign: 'center', color: '#999', padding: 40 }}>Loading...</p>
          ) : filtered.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#999', padding: 40 }}>No jobs match your search.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {filtered.map((job, i) => {
                const isOpen = activeId === job.id
                const c = COLORS[i % COLORS.length]
                const pill = PILL_COLORS[i % PILL_COLORS.length]

                return (
                  <div
                    key={job.id}
                    className="jb-card" className="shadow"
                    style={{
                      background: '#fff',
                      border: isOpen ? '1px solid #378ADD' : '0.5px solid #e5e5e5',
                      borderRadius: 12,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Header row */}
                    <div
                      className="jb-row-btn"
                      onClick={() => setActiveId(isOpen ? null : job.id)}
                      style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', cursor: 'pointer' }}
                    >
                      {/* Logo */}
                      <div style={{
                        width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                        background: c.logo, color: c.logoTxt,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 15, fontWeight: 500, letterSpacing: '.5px',
                      }}>
                        {logoLetters(job.job_title)}
                      </div>

                      {/* Title + meta */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, fontSize: 14, fontWeight: 500, color: '#1a1a1a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {job.job_title}
                        </p>
                        <p style={{ margin: 0, fontSize: 12, color: '#888', marginTop: 2 }}>
                          {job.industry_name} · {job.experience} · {job.vaccancy} vacanc{job.vaccancy == 1 ? 'y' : 'ies'}
                        </p>
                      </div>

                      {/* Category pill */}
                      <span style={{
                        fontSize: 11, padding: '3px 9px', borderRadius: 999,
                        background: pill.bg, color: pill.txt, fontWeight: 500,
                        whiteSpace: 'nowrap', flexShrink: 0,
                      }}>
                        {job.job_category_name?.category_name}
                      </span>

                      <ChevronIcon open={isOpen} />
                    </div>

                    {/* Detail panel */}
                    {isOpen && (
                      <div style={{ borderTop: '0.5px solid #eee', padding: '0 16px 20px', animation: 'jbSlide .18s ease' }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '16px 0 16px', flexWrap: 'wrap', gap: 8 }}>
                          <p style={{ margin: 0, fontSize: 16, fontWeight: 500 }}>{job.job_title}</p>
                          <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, background: '#EEEDFE', color: '#3C3489', fontWeight: 500 }}>
                            {job.job_category_name?.category_name}
                          </span>
                        </div>

                        {/* Stats grid */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8, marginBottom: 16 }}>
                          {[
                            ['Experience', job.experience],
                            ['Industry', job.industry_name],
                            ['Qualification', job.qualification],
                            ['Vacancies', job.vaccancy || '–'],
                            ['Contact', job.contact],
                          ].map(([label, val]) => (
                            <div key={label} style={{ background: '#f7f8f9', borderRadius: 8, padding: '10px 12px' }}>
                              <p style={{ margin: 0, fontSize: 11, color: '#999', marginBottom: 3 }}>{label}</p>
                              <p style={{ margin: 0, fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{val}</p>
                            </div>
                          ))}
                        </div>

                        <p style={{ margin: '0 0 6px', fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '.05em' }}>About this role</p>
                        <p style={{ margin: '0 0 16px', fontSize: 13, lineHeight: 1.7, color: '#333' }}>{job.discription}</p>

                        <hr style={{ border: 'none', borderTop: '0.5px solid #eee', margin: '14px 0' }} />

                        {/* Posted by */}
                        <p style={{ margin: '0 0 6px', fontSize: 11, color: '#999', textTransform: 'uppercase', letterSpacing: '.05em' }}>Posted By</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        
                        <hr style={{ border: 'none', borderTop: '0.5px solid #eee', margin: '14px 0' }} /> 
                        

                          <div style={{
                            width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
                            background: c.logo, color: c.logoTxt,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 12, fontWeight: 500,
                          }}>
                            {initials(job.alumini?.fullName)}
                          </div>
                          <div>
                            <p style={{ margin: 0, fontSize: 13, fontWeight: 500 }}>{job.alumini?.fullName}</p>
                            <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{job.alumini?.email}</p>
                          </div>
                          <span style={{
                            marginLeft: 'auto', fontSize: 11, padding: '3px 8px',
                            borderRadius: 999, background: '#E1F5EE', color: '#085041', fontWeight: 500,
                          }}>
                            Alumni
                          </span>
                        </div>

                        {/* Optional image */}
                        {job.jobpost_image && (
                          <>
                            <hr style={{ border: 'none', borderTop: '0.5px solid #eee', margin: '14px 0' }} />
                            <img
                              src={`${IMG_BASE_URL3}${job.jobpost_image}`}
                              alt="job"
                              style={{ width: '100%', borderRadius: 8, objectFit: 'cover' }}
                            />
                          </>
                        )}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )}

        </div>
        <div className="col-12 col-md-3" />
      </div>
    </div>
  )
}